import React from 'react';

export function WarningBanner(props: any) {
	if (!props.warn || !props.message) return null;
	return <div className="warning">{props.message}</div>;
}
